import "./Auth.css";
import { Button, Input} from "antd";
import { faEye, faEyeSlash } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Flex, useMediaQuery } from "@chakra-ui/react";
import logoPix from "../../../assets/images/logoPix.png";

const Auth = (props) => {
  const [isLargerThan800] = useMediaQuery("(min-width: 800px)");
  const {
    authFields,
    authSubmit,
    onsubmit,
    successMessage,
    errorMessage,
    contactAdminError    
  } = props;
  return (
    <Flex
      width="100%"
      height="100vh"
      justifyContent="center"
      alignItems="center"
      backgroundColor="#161920"
      flexDirection="column"
      gap="40px"
    >
      <img src={logoPix} alt="logo" style={{ width: "250px" }} />
      <form
        onSubmit={onsubmit}
        style={{
          backgroundColor: "#1F2630",
          padding: "30px",
          display: "flex",
          flexDirection: "column",
          gap: "20px",
          borderRadius: "30px",
          border: "1px solid white",
          minWidth: isLargerThan800 ? "400px" : "90%",
        }}
      >
        {authFields.map((itemField, indexField) => {
          switch (itemField.type) {
            case "text":
              return (
                <div key={indexField}>
                  <Input
                    placeholder={itemField.placeholder ?? ""}
                    value={itemField.value}
                    id="username"
                    type="text"
                    name="username"
                    autoComplete="username"
                    onChange={(event) => {
                      if (typeof itemField.setField === "function") {
                        itemField.setField(event.target.value);
                      }
                    }}
                    onKeyPress={(event) => {
                      if (event.key === "Enter") {
                        onsubmit();
                      }
                    }}
                  />
                  {itemField.error && (
                    <div className="Admin_Auth_itemFieldError">
                      {itemField.error}
                    </div>
                  )}
                </div>
              );
            case "password":
              return (
                <div key={indexField}>
                  <Input.Password
                    placeholder={itemField.placeholder ?? ""}
                    id="password"
                    value={itemField.value}
                    type="password"
                    name="password"
                    autoComplete="current-password"
                    iconRender={(visible) =>
                      visible ? (
                        <FontAwesomeIcon icon={faEyeSlash}></FontAwesomeIcon>
                      ) : (
                        <FontAwesomeIcon icon={faEye}></FontAwesomeIcon>
                      )
                    }
                    onChange={(event) => {
                      if (typeof itemField.setField === "function") {
                        itemField.setField(event.target.value);
                      }
                    }}
                    onKeyPress={(event) => {
                      if (event.key === "Enter") {
                        onsubmit();
                      }
                    }}
                  />
                  {itemField.error && (
                    <div style={{ color: "#e46772", fontWeight: 400 }}>
                      {itemField.error}
                    </div>
                  )}
                </div>
              );
            default:
              return null;
          }
        })}
        <Button
          onClick={() => {
            if (typeof onsubmit === "function") {
              onsubmit();
            }
          }}
        >
          {authSubmit.toUpperCase()}
        </Button>
      </form>

      {successMessage && (
        <div className="Admin_Auth_successMessage">{successMessage}</div>
      )}
      {errorMessage && (
        <div className="Admin_Auth_errorMessage">
          <div
            dangerouslySetInnerHTML={{
              __html: "Erro, algo deu errado Senha ou Email Inválido.",
            }}
          ></div>
        </div>
      )}
      {contactAdminError && (
        <div className="Admin_Auth_errorMessage">Entre em contato com Admin do sistema via whatsapp <a href="https://wa.me/8199820170?text=Olá! estou entrando em contato para solicitar meu reset de senha" target='_blank' rel="noreferrer">Clicando aqui</a> </div>
      )}
    </Flex>
  );
};

export default Auth;
